export default __webpack_public_path__ + "static/media/yt_nibiru-ep4.980afc7f.jpg";